<template>
  <div
    :class="`sam-form-group is-${samStyle} is-type-${samType}`"
    data-samora
  >
    <div class="sam-form-group__header">
      <span class="sam-form-group__header-label">{{ label || '&nbsp;' }}</span>
      <span
        v-if="!required"
        class="sam-form-group__header-optional"
      >
        {{ SAMORA_TEXTS.FORM_GROUP.OPTIONAL }}</span
      >
    </div>

    <span
      v-if="loading"
      class="sam-form-group__loading"
    />
    <template v-else>
      <div class="sam-form-group__input">
        <slot></slot>
      </div>
      <div
        v-if="!hideMessage"
        class="sam-form-group__message"
        :class="{ 'is-error': invalid }"
      >
        {{ message || '&nbsp;' }}
      </div>
    </template>
  </div>
</template>

<script>
import SAMORA_TEXTS from '../../../utils/constants/samora-texts.enum';
import SAMORA_STYLES from '../../../utils/constants/samora-styles.enum';
import SAMORA_TYPES from '../../../utils/constants/samora-types.enum';

const { FORM_GROUP: SAMORA_FORM_GROUP_TYPES } = SAMORA_TYPES;

export const FORM_GROUP_TYPES = SAMORA_FORM_GROUP_TYPES;

export const FORM_GROUP_STYLES = {
  DEFAULT: SAMORA_STYLES.DEFAULT,
  INACTIVE: SAMORA_STYLES.INACTIVE,
};

export default {
  name: 'SamFormGroup',
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
      required: false,
    },
    message: {
      type: String,
      default: '',
      required: false,
    },
    hideMessage: {
      type: Boolean,
      default: false,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    invalid: {
      type: Boolean,
      default: false,
      required: false,
    },
    samStyle: {
      type: String,
      default: SAMORA_STYLES.DEFAULT,
      required: false,
      validator: (val) => Object.values(FORM_GROUP_STYLES).includes(val),
    },
    samType: {
      type: String,
      default: FORM_GROUP_TYPES.NONE,
      required: false,
      validator: (val) => Object.values(FORM_GROUP_TYPES).includes(val),
    },
  },
  data: () => ({
    SAMORA_TEXTS,
  }),
};
</script>

<style scoped lang="scss">
.sam-form-group {
  display: inline;
  width: 100%;

  &__header {
    @extend .d-flex, .between-xs, .text--caption;
    color: $neutral--80;
    width: 100%;

    &-optional {
      font-style: italic;
    }
  }

  &__input {
    @extend .mt-1;

    &:not(:last-child) {
      @extend .mb-2;
    }
  }

  &__message {
    @extend .text--caption;
    color: $neutral--80;

    &.is-error {
      color: $error--main;
    }
  }

  &__loading {
    display: block;
    height: $size--4;
    margin: $size--4 0;
    width: 75%;
    @include old-skeleton-blink;
  }

  &.is-type-input {
    box-sizing: border-box;
  }

  &.is-type-input-group {
    box-sizing: border-box;
    max-width: 480px;
  }

  &.is-inactive {
    .sam-form-group__header {
      &-optional {
        color: $neutral--40;
      }

      &-label {
        color: $neutral--50;
      }
    }

    .sam-form-group__message {
      color: $neutral--50;
    }
  }
}
</style>
